import React from "react";
import ReactDOM from 'react-dom';
import { NavLink } from "react-router-dom";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import cartReducer from './reducers';
import { Provider } from 'react-redux';
import { createStore } from 'redux';

import Navigation from './Navigation';
import Home from './Home';
import SingleProduct from './SingleProduct';
import Cart from './Cart';
import Checkout from './Checkout'
// import Checkout from './Checkout';

const store = createStore(cartReducer);
window.popupCounter = 0;

ReactDOM.render(
	<Provider store={store}>
		<Router>
			<Navigation />
			<div>
				<Routes>
        			<Route path="/" element={<Home />} />	
        			<Route path="/SingleProduct" element={<SingleProduct />} />			
        			<Route path="/Cart" element={<Cart />} />	
        			<Route path="/Checkout" element={<Checkout />} />						
				</Routes>			
			</div>
			<div id = "popupWindow" style = {{position: "fixed", left:"80%", top: "80%", minHeight: "30px", display: 'none'}}>
				<div className="alert alert-success" role="alert">
				  Product added to cart!
				</div>
			</div>
		</Router>
	</Provider>,
		document.querySelector('#root')
);